export const datatable = {
  ICON_EYE: 'fa fa-eye',
  ICON_EDIT: 'fa fa-edit',
  ICON_TRASH: 'fa fa-trash',

  MDI_MAGNIFY: 'mdi-magnify',
};

export const modal = {
  ICON_TRASH: 'fa fa-trash',
};

export const list = {
  ICON_PLUS: 'fas fa-plus',
  ICON_TRASH: 'fas fa-trash',
};

export const create = {
  ICON_PLUS: 'fa fa-plus',
  ICON_EDIT: 'fa fa-edit',
  ICON_TRASH: 'fa fa-trash',
  ICON_ANGLE_UP: 'fas fa-angle-up',
  ICON_ANGLE_DOWN: 'fas fa-angle-down',
};

export const edit = {
  ICON_PLUS: 'fa fa-plus',
  ICON_EYE: 'fa fa-eye',
  ICON_EDIT: 'fa fa-edit',
  ICON_TRASH: 'fa fa-trash',
  ICON_ANGLE_UP: 'fas fa-angle-up',
  ICON_ANGLE_DOWN: 'fas fa-angle-down',
};

export const show = {
  ICON_PLUS: 'fa fa-plus',
  ICON_EDIT: 'fa fa-edit',
  ICON_INFO_CIRCLE: 'fa fa-info-circle',
  ICON_ANGLE_UP: 'fas fa-angle-up',
  ICON_ANGLE_DOWN: 'fas fa-angle-down',
};
